<template>
  <div></div>
</template>
<script>
// 空白路由，起到点击同一路由过渡跳转，相当于是刷新当前路由
export default {
  data() {
    return {};
  },
  created() {
    const path = this.$route.query.path;
    const id = this.$route.query.id;
    const params = id ? { id: id } : {};
    this.$router.push({
      path: path,
      query: params,
    });
  },
};
</script>
<style></style>
